import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "../../../../lib/axios";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: 'transparent',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },
  '& .Mui-focused': {
    borderColor: '#673ab7',
  },
  '& .MuiFilledInput-root.Mui-focused': {
    border: '1px solid #673ab7',
  },
}));

const PropertyType = () => {
  const [formData, setFormData] = useState({
    PropType: '',
    PropType_Desc: '',
    Remark: ''
  });

  const [error, setError] = useState({
    propType: false,
    propType_Desc: false,
    remark: false
  });

  const navigate = useNavigate();

  const [isEditMode, setIsEditMode] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [propTypeId, setPropTypeId] = useState(null);
  const location = useLocation();
  const [currentPropTypeId, setCurrentPropTypeId] = useState(null);
  const [isViewMode, setIsViewMode] = useState(false);
  const [mode, setMode] = useState('view');
  const [lastInsertedPropTypeId, setLastInsertedPropTypeId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));

  const propTypeRef = useRef(null);
  const propType_DescRef = useRef(null);
  const remarkRef = useRef(null);

  useEffect(() => {
    if (location.state && location.state.PropTypeId) {
      setCurrentPropTypeId(location.state.PropTypeId);
      fetchPropertyTypeData(location.state.PropTypeId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchPropertyTypeData = async (id, flag) => {
    try {
      const response = await axios.post(`PropTypeMst/RetrivePropTypeMst`, {
        PropTypeId: parseInt(id),
        Flag: flag
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const propertyTypeData = response.data.Data[0];
        setFormData({
          PropType: propertyTypeData.PropType,
          PropType_Desc: propertyTypeData.PropType_Desc,
          Remark: propertyTypeData.Remark
        });
        setIsFormDisabled(true);
        setCurrentPropTypeId(propertyTypeData.PropTypeId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch propertyType data');
      }
    } catch (error) {
      console.error('Error fetching propertyType data:', error);
      toast.error('Error fetching propertyType data. Please try again.');
    }
  };

  const handlePrevious = async () => {
    if (currentPropTypeId && currentPropTypeId > 1) {
      await fetchPropertyTypeData(currentPropTypeId, "P");
    }
  };

  const handleNext = async () => {
    if (currentPropTypeId) {
      await fetchPropertyTypeData(currentPropTypeId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'propertyType') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }

    if (name === 'propertyType' && value !== '') {
      setTimeout(() => {
        remarkRef.current.focus();
      }, 100000);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === propType_DescRef.current) {
        remarkRef.current.focus();
      } else {
        propType_DescRef.current.focus();
      }
    }
  };

  const handleSave = async () => {

    let hasError = false;

    if (!formData.PropType) {
      toast.error('PropertyType is required');
      setError(prev => ({ ...prev, propType: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, propType: false }));
    }

    // if (!formData.propType_Desc) {
    //   toast.error('Description is required');
    //   setError(prev => ({ ...prev, propType_Desc: true }));
    //   hasError = true;
    // } else {
    //   setError(prev => ({ ...prev, propType_Desc: false }));
    // }

    // if (!formData.remark) {
    //   toast.error('Description is required');
    //   setError(prev => ({ ...prev, remark: true }));
    //   hasError = true;
    // } else {
    //   setError(prev => ({ ...prev, remark: false }));
    // }

    if (hasError) {
      return;
    }


    try {
      const payload = {
        PropType: formData.PropType,
        PropType_Desc: formData.PropType_Desc,
        Remark: formData.Remark,
        Status: "1"
      };

      let response;
      if (mode === 'edit') {
        payload.PropTypeId = currentPropTypeId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axios.patch(`PropTypeMst/UpdatePropTypeMst`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post(`PropTypeMst/InsertPropTypeMst`, payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedPropTypeId(response.data.Data)
          console.log(response.data.Data)
          await fetchPropertyTypeData(response.data.Data);
          // setFormData({
          //   country: '',
          //   state: '',
          //   zone: '',
          //   city: '',
          //   shortName: '',
          //   cityCode: ''
          // });
          setMode('view');
          setIsFormDisabled(true);
          setCurrentPropTypeId(response.data.Data);
        } else {
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving/updating propertyType:', error);
      toast.error('Error saving/updating propertyType. Please try again.');
    }
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(currentPropTypeId, "MstPropType", "PropTypeId");
    console.log(Flag);
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      PropType: '',
      PropType_Desc: '',
      Remark: ''
    });
    setCurrentPropTypeId(null);

    setTimeout(() => {
      propTypeRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchPropertyTypeData(1, "L");
      await UnLock(currentPropTypeId, "MstPropType", "PropTypeId");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      PropType: '',
      PropType_Desc: '',
      Remark: ''
    });
    setCurrentPropTypeId(null);
    setMode('view');
  };

  const handleExit = () => {
    navigate('/propertyTypetable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {

    let Flag = await checkAndLock(currentPropTypeId, "MstPropType", "PropTypeId");
    console.log(Flag);
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchPropertyTypeData(currentPropTypeId, "D");
        await fetchPropertyTypeData(currentPropTypeId, "N");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }

  };

  return (
    <>

      <Box className="form-container">

        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px' }}>
            <Grid>
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                disabled={mode !== 'view' || !currentPropTypeId || currentPropTypeId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{ margin: '0px 10px' }}
                className='three-d-button-next'
                onClick={handleNext}
                disabled={mode !== 'view' || !currentPropTypeId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <h3 style={{}}>PropertyType Master</h3>
            <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635bff' }}
                onClick={handleAdd}
                disabled={mode !== 'view' || !currentPropTypeId}
              >
                <AddIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635bff', margin: '0px 10px' }}
                onClick={handleEdit}
                disabled={mode !== 'view' || !currentPropTypeId}
              >
                <EditIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635bff' }}
                onClick={handleDeleteClick}
                disabled={mode !== 'view' || !currentPropTypeId || currentPropTypeId === 0}
              >
                <DeleteIcon />
              </Button>


              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635bff', margin: '0px 10px' }}
                onClick={handleExit}
                disabled={mode !== 'view' || !currentPropTypeId}
              >
                <CancelPresentationIcon />
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12} className='form_field'>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="PropType"
                  name="PropType"
                  label={
                    <span>
                      PropType <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.PropType}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.propType}
                  helperText={error.propType && ""}
                  inputRef={propTypeRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="PropType_Desc"
                  name="PropType_Desc"
                  label="Description"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.PropType_Desc}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={propType_DescRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={remarkRef}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                  // disabled={!currentZoneId}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>

                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>

              </>
            )}
          </Grid>
        </Grid>
      </Box>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default PropertyType;